import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import { RichText } from "prismic-reactjs";
import "./caseStudy.scss";
import { Link } from "gatsby";
import { AppContext } from "../layout/shell";
export var CaseStudy = function CaseStudy(_ref) {
  var data = _ref.data;

  var _React$useContext = React.useContext(AppContext),
      isMobile = _React$useContext.isMobile;

  var hasBackgroundImage = !!data.primary.background_image1 && !isMobile;
  var imageSrc = data.primary.background_image1 ? data.primary.background_image1["url"] : null;
  var imageAlt = data.primary.background_image1 && data.primary.background_image1["alt"];
  var imageCopyright = data.primary.background_image1 && data.primary.background_image1["copyright"];
  var style = hasBackgroundImage ? {
    backgroundImage: "url('" + imageSrc + "')"
  } : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "case-study"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, /*#__PURE__*/React.createElement("h4", null, data.primary.sub_header), /*#__PURE__*/React.createElement("h2", null, data.primary.header), /*#__PURE__*/React.createElement("h3", null, data.primary.header_2), RichText.render(data.primary.intro_body), !isMobile && /*#__PURE__*/React.createElement(Link, {
    className: "btn",
    to: data.primary.path
  }, data.primary.action), isMobile && /*#__PURE__*/React.createElement("img", {
    src: imageSrc,
    alt: imageAlt
  }), /*#__PURE__*/React.createElement("div", {
    className: "case-study-body",
    style: style
  }, imageCopyright && /*#__PURE__*/React.createElement("p", {
    className: "image-copyright"
  }, imageCopyright), /*#__PURE__*/React.createElement("div", {
    className: "case-study-content"
  }, /*#__PURE__*/React.createElement("h3", null, handleLineBreaks(data.primary.case_study_header)), RichText.render(data.primary.case_study_content)))));
};